export const LOGO = "/logo.png";

const U = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  heroSwirl: "https://images.pexels.com/photos/31687152/pexels-photo-31687152.jpeg",
  dubai: "https://images.pexels.com/photos/1381722/pexels-photo-1381722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  servers: "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  dottedMap: "https://images.unsplash.com/photo-1770486036751-e55247238964?crop=entropy&cs=srgb&fm=jpg&q=85",
  workspace: "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?crop=entropy&cs=srgb&fm=jpg&q=85",
  circuit: U("1518770660439-4636190af475", 1600),
  render3d: U("1639322537228-f710d846310a", 1600),
  code: U("1461749280684-dccba630e2f6", 1400),
  network: U("1451187580459-43490279c0fa", 1600),
  matrix: U("1526374965328-7f61d4dc18c5", 1400),
  culture: [
    U("1531482615713-2afd69097998", 900),
    U("1497366216548-37526070297c", 900),
    U("1573164713988-8665fc963095", 900),
    U("1487058792275-0ad4aaf24ca7", 900),
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  email: "contact@stratflowtech.com",
  website: "www.stratflowtech.com",
  address: "Unit 3701, 3702, 3703 HDS Towers, JLT, Dubai",
  city: "Dubai, United Arab Emirates",
};

export const SERVICES = [
  {
    id: "ai",
    icon: "sparkles",
    img: U("1614064641938-3bbee52942c7"),
    title: "Artificial Intelligence",
    tag: "Applied AI & LLMs",
    desc: "Production-grade AI systems — LLM copilots, RAG pipelines, forecasting and computer vision — engineered to ship, scale and stay reliable.",
    points: ["LLM & RAG platforms", "Predictive analytics", "Intelligent automation"],
    span: "lg:col-span-7",
  },
  {
    id: "crm",
    icon: "users",
    img: U("1552581234-26160f608093"),
    title: "CRM Engineering",
    tag: "Revenue systems",
    desc: "Bespoke CRMs that unify pipeline, service and marketing into one glossy source of truth.",
    points: ["360° customer view", "Workflow automation", "Deep integrations"],
    span: "lg:col-span-5",
  },
  {
    id: "cms",
    icon: "layout-panel-left",
    img: U("1467232004584-a241de8bcf5d"),
    title: "CMS Platforms",
    tag: "Content at scale",
    desc: "Headless, blazing-fast content platforms with editorial polish and enterprise governance.",
    points: ["Headless architecture", "Multi-market publishing", "Edge delivery"],
    span: "lg:col-span-5",
  },
  {
    id: "fintech",
    icon: "line-chart",
    img: U("1611974789855-9c2a0a7236a3"),
    title: "Financial Systems",
    tag: "Fintech expertise",
    desc: "Ledgers, payments, reconciliation and trading infrastructure built for precision, audit and scale.",
    points: ["Double-entry ledgers", "Payments & PCI", "Real-time reconciliation"],
    span: "lg:col-span-7",
  },
  {
    id: "security",
    icon: "shield-check",
    img: U("1550751827-4bd374c3f58b"),
    title: "Security Expertise",
    tag: "Zero-trust by design",
    desc: "Threat modelling, zero-trust architecture and continuous hardening baked into every layer.",
    points: ["Zero-trust design", "Pen-testing & audits", "SOC-ready compliance"],
    span: "lg:col-span-6",
  },
  {
    id: "devops",
    icon: "cloud",
    img: U("1544197150-b99a580bb7a8"),
    title: "Cloud & DevOps",
    tag: "AWS · Azure · Alibaba",
    desc: "Multi-cloud infrastructure, IaC and CI/CD that turns deployments into a non-event.",
    points: ["AWS · Azure · Alibaba", "Kubernetes & IaC", "Observability & SRE"],
    span: "lg:col-span-6",
  },
];

export const METRICS = [
  { value: "99.99%", label: "Guaranteed uptime", sub: "TP99.99 SLA across regions" },
  { value: "40+", label: "Systems shipped", sub: "AI, fintech & platforms" },
  { value: "12", label: "Countries served", sub: "Clients across 4 continents" },
  { value: "24/7", label: "Global support", sub: "Follow-the-sun SRE" },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "We build the infrastructure of tomorrow",
    body: "StratFlow Tech FZCO is a Dubai-headquartered engineering studio. We partner with ambitious teams to design, build and scale software that carries real business weight — from intelligent AI products to mission-critical financial systems.",
  },
  {
    num: "02",
    title: "Craft is our default, not our upgrade",
    body: "Every interface, endpoint and pipeline is treated as a product. We obsess over performance, security and the small details that make software feel effortless and premium.",
  },
  {
    num: "03",
    title: "Reliability you can set your watch to",
    body: "With a TP99.99 reliability posture and follow-the-sun operations, our systems stay online when it matters most. Uptime isn't a promise — it's an engineered outcome.",
  },
  {
    num: "04",
    title: "Global reach, Dubai roots",
    body: "From JLT to clients across four continents, we bring together diverse talent and a single obsession: building technology that moves organisations forward.",
  },
];

export const HUBS = [
  { name: "Dubai", x: 60, y: 52, hq: true },
  { name: "London", x: 45.5, y: 34 },
  { name: "New York", x: 24, y: 41 },
  { name: "Singapore", x: 74, y: 62 },
  { name: "Riyadh", x: 58.5, y: 50 },
  { name: "Berlin", x: 49, y: 32 },
];

export const ARCS = [
  ["Dubai", "London"],
  ["Dubai", "New York"],
  ["Dubai", "Singapore"],
  ["London", "New York"],
  ["Dubai", "Berlin"],
];

export const MARQUEE = [
  "Artificial Intelligence", "CRM", "CMS", "Financial Systems", "Security",
  "AWS", "Azure", "Alibaba Cloud", "Kubernetes", "LLM & RAG", "Zero-Trust",
  "Payments", "Observability", "TP99.99", "DevOps",
];
